export default __webpack_public_path__ + "images/logo192.png";